import { render } from "./TheMenu.vue?vue&type=template&id=39c96ee4&scoped=true"
import script from "./TheMenu.vue?vue&type=script&lang=js"
export * from "./TheMenu.vue?vue&type=script&lang=js"

import "./TheMenu.vue?vue&type=style&index=0&id=39c96ee4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-39c96ee4"

export default script